<template>

    <div class="col-12">
        <div v-if="errors">
            {{ errors }}
        </div>
        <form>

            <div class="row">
                <div class="form-search-wrap col-12">
                    <div class="choices-filter-group double">
                        <input type="text" name="keyword" id="keyword" placeholder="Enter a keyword, order number, program name, or network name" v-model="query_keyword" >
                    </div>
                </div>

                <div class="col-12 pt-2 pull-right ">
                    <a class="pull-right clear-button no-border cursor-pointer" v-on:click.stop="clearSearch()">
                        <close-icon></close-icon>
                        Clear Search</a>
                </div>
            </div>

        </form>
        <br/>

        <div class="entries-table-wrap">
            <table id="sortable-table nice-table">
                <thead>

                <tr class="tableHeaderRow">
                    <th style="width: 145px;" class="cursor-pointer th-entry pl-2" v-on:click="setSort('order_id')">Submission # <i class="fa" :class="((sort_order != 'desc') && (sort == 'order_id')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                    <th class="cursor-pointer th-program" v-on:click="setSort('program_title')">Program <i class="fa" :class="((sort_order != 'desc') && (sort == 'program_title')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                    <th class="cursor-pointer th-network" v-on:click="setSort('cable_network')">Network <i class="fa" :class="((sort_order != 'desc') && (sort == 'cable_network')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                    <th style="width: 130px;" class="cursor-pointer th-status" v-on:click="setSort('order_status')">
                        Status <i class="fa" :class="((sort_order != 'desc') && (sort == 'order_status')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                </tr>
                </thead>
                <tbody v-for="(order,i) in orders.data" >
                <tr @click="loadOrder(order.order_id)" class="cursor-pointer">
                    <td  class="pl-2"><div>{{ order.order_id }}</div></td>
                    <td><div>{{ order.program_title }}</div></td>
                    <td><div>{{ order.cable_network }}</div></td>
                    <td class="status">
                        <div class="">
                            {{ orderStatusHumanReadable(order.order_status) }}
                        </div>
                        <div class="actions">
<!--                            <a :href="'/order/'+order.order_id"><i  class="fa fa-edit"></i>Edit</a>-->
<!--                            <a :href="'/order/'+order.order_id"><i  class="fa fa-trash"></i>Delete</a>-->
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div style="float:right;">
            <pagination :data="orders" @pagination-change-page="paginationCalculator" :limit="3">
                <span slot="prev-nav">&lt; Previous</span>
                <span slot="next-nav">Next &gt;</span>
            </pagination>
        </div>
        <div class="dataTables_info">Showing 1-{{to}} of {{ total }} orders</div>
        <div class="dataTables_length admin-entry-table">
            <label>
                <span>Show</span>
                <select class="plain-select num-entries-select" v-model="num">
                    <option value="10">10 Orders</option>
                    <option value="20">20 Orders</option>
                    <option value="50">50 Orders</option>
                    <option value="100">100 Orders</option>
                </select>
                <span>per page</span>
            </label>
        </div>

    </div>
</template>

<script>
    import CloseIcon from "../Icons/close.vue";

    export default {
        name: "OrdersTableSearch",
        components: {CloseIcon},
        data() {
            return {
                errors: false,
                num:20,
                page:1,
                total: 0,
                to: 0,
                sort:'',
                sort_order: 'desc',
                orders: {},
                query_keyword: (localStorage.getItem('honors-history-search') != null) ? localStorage.getItem('honors-history-search') : '',
                query_order_status: '',
                query_order_type: '',
                query_file_status: '',
                order_status_options: [{
                    text: "In Progress",
                    id: "in_progress"
                }, {
                    text: "Submitted",
                    id: "submitted"
                }, {
                    text: "Canceled",
                    id: "canceled"
                }, {
                    text: "Approved",
                    id: "approved"
                }, {
                    text: "Ineligible",
                    id: "ineligible"
                }, {
                    text: "Live",
                    id: "live"
                }, {
                    text: "Live - Checked",
                    id: "live_checked"
                }],
                order_type_options: [{
                    'text': 'Viewing Platform',
                    'id': 'Viewing Platform'
                }, {
                    'text': 'Network',
                    'id': 'Network'
                }],
                file_status_options: [
                    'Video Approved',
                    'Need More Info',
                    'Upload Successful',
                    'Processing',
                    'Failed',
                    'Submitted'],
            }
        },
        mounted() {
            if(localStorage.getItem('honors-history-search-sort')) {
                this.sort = localStorage.getItem('honors-history-search-sort');
            }
            if(localStorage.getItem('honors-history-search-sort-order')) {
                this.sort_order = localStorage.getItem('honors-history-search-sort-order');
            }
            if(localStorage.getItem('honors-history-search-num')) {
                this.num = localStorage.getItem('honors-history-search-num');
            }
            if(localStorage.getItem('honors-history-search-page')) {
                this.page = localStorage.getItem('honors-history-search-page');
            }
            if(localStorage.getItem('honors-history-search-status')) {
                var searchStatus = localStorage.getItem('honors-history-search-status');
                this.query_order_status = searchStatus.split(',');
            }
            if(localStorage.getItem('honors-history-search-filestatus')) {
                var searchFileStatus = localStorage.getItem('honors-history-search-filestatus');
                this.query_file_status = searchFileStatus.split(',');
            }
            if(localStorage.getItem('honors-history-search-type')) {
                this.query_order_type = localStorage.getItem('honors-history-search-type');
            }
            this.fetchOrders(this.page);
        },
        methods:{
            orderStatusHumanReadable(inputStatus) {

                switch(inputStatus) {
                    case 'in_progress':
                        return 'In Progress';
                    case 'pre_approved':
                        return 'In Progress';
                    case 'live_checked':
                        return 'Live Checked';
                    case 'need_more_info':
                        return 'Need More Info';
                    default:
                        return inputStatus;
                }
            },
            loadOrder(order_id){
                window.location = '/submission/'+order_id;
            },
            fetchOrders(page = 1){
                let app = this;
                axios.get('/api/orders', {
                    params: {
                        num: app.num,
                        page: page,
                        sort: app.sort,
                        sort_order: app.sort_order,
                        keyword: app.query_keyword,
                        order_status: app.query_order_status,
                        file_status: app.query_file_status,
                        order_type: app.query_order_type
                        }
                    })
                    .then(res => {
                        app.orders = res.data;
                        app.total = res.data.total;
                        app.to = res.data.to;
                        localStorage.setItem('honors-history-search-to', app.to);
                        localStorage.setItem('honors-history-search', app.query_keyword);
                        localStorage.setItem('honors-history-search-status', app.query_order_status);
                        localStorage.setItem('honors-history-search-filestatus', app.query_file_status);
                        localStorage.setItem('honors-history-search-type', app.query_order_type);
                        localStorage.setItem('honors-history-search-num', app.num);
                    }).catch(err => {
                    this.errors = 'Error contacting the server : ';
                    this.errors += err;
                    console.log(err)
                });
            },
            setSort(sort) {
                if (this.sort == sort) {
                    this.sort_order = (this.sort_order == 'desc')?'asc':'desc';
                } else {
                    this.sort = sort;
                    this.sort_order = 'desc';
                }
                localStorage.setItem('honors-history-search-sort', this.sort);
                localStorage.setItem('honors-history-search-sort-order', this.sort_order);
                this.fetchOrders();
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace(',', '.')
                return '$'+val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            openAssignModal(i){
                this.assigned_invoice = this.invoices[i];
                this.check_assign_amount = this.assigned_invoice.amount_due.toFixed(2);
                this.assignCheckModal = true;
            },
            assignCheck() {
                let app = this;
                if (!(app.check_assign_amount > 0)) {
                    alert("Check amount needs to be a value");
                    return;
                }
                app.assignCheckModal = false;
                axios.post('/api/finance/apply_check', {
                    check_assign_amount: app.check_assign_amount,
                    check_assign_number: app.check_assign_number,
                    check_assign_notes: app.check_assign_notes,
                    invoice_id: app.assigned_invoice.id,
                })
                    .then(res => {
                        this.errors = res.data;
                    }).catch(err => {
                    this.errors = 'Error contacting the server : ';
                    this.errors += err;
                    console.log(err)
                });
                window.location.reload();
            },
            clearSearch: function() {
                this.query_keyword = '';
                this.sort = '';
                this.sort_order = 'desc';
                this.num = 20;
                this.query_order_status = '';
                this.query_file_status = '';
                this.query_order_type = '';
                localStorage.removeItem('honors-history-search');
                localStorage.removeItem('honors-history-search-status');
                localStorage.removeItem('honors-history-search-filestatus');
                localStorage.removeItem('honors-history-search-type');
                localStorage.removeItem('honors-history-search-sort');
                localStorage.removeItem('honors-history-search-sort-order');
                localStorage.removeItem('honors-history-search-num');
                localStorage.removeItem('honors-history-search-page');
            },
            paginationCalculator: function(pageIndex) {
                localStorage.setItem('honors-history-search-page', pageIndex);
                this.fetchOrders(pageIndex);
            }
        },
        watch: {
            query_keyword() {
                // clear the pagination when the keyword is changing
                localStorage.removeItem('honors-history-search-page');
                this.fetchOrders(this.page);
                },
            query_order_status() {
                localStorage.removeItem('honors-history-search-page');
                this.fetchOrders(this.page);
                },
            query_file_status() {
                localStorage.removeItem('honors-history-search-page');
                this.fetchOrders(this.page);
            },
            query_order_type() {
                localStorage.removeItem('honors-history-search-page');
                this.fetchOrders(this.page);
            },
        }
    }
</script>
